import React from 'react';
import { Box, Copy, Label, Optional } from '@honda-canada/design-system-react';
import PaymentCalculatorTooltipAnchor from '../PaymentCalculatorTooltipAnchor';
import themeStyles from './LabeledCheckbox.styles';
import InlineTextAndTooltip from '../../../../utils/components/InlineTextTooltip';
const Container = themeStyles.apply(Box, 'Container');
const CheckboxWrapper = themeStyles.apply(Box, 'CheckboxWrapper');
const LabelWrapper = themeStyles.apply(Box, 'LabelWrapper');
const StyledTooltip = themeStyles.apply(PaymentCalculatorTooltipAnchor, 'StyledTooltip');
const labelStyles = {
    lineHeight: ['22px', '22px', '26px'],
    fontSize: ['14px', '14px', '16px'],
    fontFamily: 'default',
    alignSelf: 'center',
    cursor: 'default',
};
const LabeledItem = ({ label, name, rightSideText, suppressSelected, tooltipText, onClick = () => null, children, }) => (React.createElement(Container, null,
    React.createElement(LabelWrapper, { onClick: () => onClick(name) },
        React.createElement(Optional, { when: !suppressSelected },
            React.createElement(CheckboxWrapper, null, children)),
        React.createElement(Label, { suppressCheckbox: true, htmlFor: suppressSelected ? '' : name, styledProps: labelStyles, "data-testid": `cy-${name}-checkbox-label` },
            React.createElement(InlineTextAndTooltip, { text: label },
                React.createElement(Optional, { when: tooltipText },
                    React.createElement(StyledTooltip, { "data-testid": `cy-${name}-checkbox-tooltip` }, tooltipText))))),
    React.createElement(Optional, { when: rightSideText },
        React.createElement(Copy, { ml: "xs", size: "regular", fontFamily: "bold", style: { flexShrink: 0 }, "data-testid": `cy-${name}-checkbox-value` }, rightSideText))));
export default LabeledItem;
